module.exports = __webpack_public_path__ + "static/media/fontawesome-webfont.776d58f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/CSS/assets-minified/icons/fontawesome/fontawesome-webfont.svg
// module id = ./src/CSS/assets-minified/icons/fontawesome/fontawesome-webfont.svg
// module chunks = 0